import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { get, find, filter, set } from "lodash";
import(
  /* webpackChunkName: "order-builder-ear-pieces-family-model" */ "./earPiecesFamilyModel.scss"
);

import testModel from "../../../../assets/img/ModelTest.png";

const EarPiecesFamilyModel = ({
  productsData,
  selectedModel,
  initialProductCategory,
  setSelectedModel,
  initialModelCode,
}) => {
  const [ricProductsArray, setRICProductsArray] = useState();
  const [selectedFamily, setSelectedFamily] = useState();
  const [modelsArray, setModelsArray] = useState();
  const [selectedLocalModel, setSelectedLocalModel] = useState();

  useEffect(() => {
    if (productsData) {
      // Filters products to only show RIC and BTE items for the family and mode dropdowns
      // let tempRICProductsArray = [...productsData];

      // tempRICProductsArray = find(tempRICProductsArray, {
      //   Name: "BTE/RICs" || "ITEs",
      // });
      // tempRICProductsArray = get(
      //   tempRICProductsArray,
      //   "InverseParentCodeNavigation",
      //   []
      // );
      // // console.log("tempRICProductsArray", tempRICProductsArray);
      // setRICProductsArray(tempRICProductsArray);

      const bteRicCategory = find(productsData, {
        Name: "BTE/RICs",
      });

      const iteCategory = find(productsData, {
        Name: "ITEs",
      });

      const bteRicFamilies = get(
        bteRicCategory,
        "InverseParentCodeNavigation",
        []
      );

      const iteFamilies = get(
        iteCategory,
        "InverseParentCodeNavigation",
        []
      );

      const combinedFamilies = [
        ...bteRicFamilies,
        ...iteFamilies,
      ];

      setRICProductsArray(combinedFamilies);

      // console.log("initialProductCategory", initialProductCategory);
      if (
        initialProductCategory != "Earpiece" &&
        initialProductCategory != "AccRgrChg" &&
        initialProductCategory != "Repair" &&
        !initialProductCategory.includes("Earpiece")
      ) {
        // const familySelected = filter(
        //   tempRICProductsArray,
        //   (item) => item.Code && item.Code.includes(initialProductCategory)
        // );
        const familySelected = filter(
          combinedFamilies,
          (item) => item.Code && item.Code.includes(initialProductCategory)
        );
        // console.log("setSelectedFamily", familySelected[0].Code);
        setSelectedFamily(familySelected[0].Code);
      }
    }
  }, [productsData]);

  useEffect(() => {
    // On family change update the model dropdown
    // console.log("ricProductsArray", ricProductsArray);
    // console.log("selectedFamily", selectedFamily);
    if (selectedFamily && selectedFamily != "Unknown") {
      // const modelsArray = find(ricProductsArray, { Code: selectedFamily }, {});
      const modelsArray = filter(
        ricProductsArray,
        (item) => item.Code && item.Code.includes(selectedFamily)
      )[0];
      // console.log("On family change - selectedFamily",selectedFamily)
      // console.log("modelsArray", modelsArray);
      // console.log("modelsArray.ModelTypes", modelsArray.ModelTypes);
      // setModelsArray(modelsArray.SoModelTypes);
      setModelsArray(modelsArray.ModelTypes);
      // console.log("initialModelCode", initialModelCode);
      if (initialModelCode) {
        // set initial model
        setSelectedLocalModel(initialModelCode);
        const modelObj = find(
          // modelsArray.SoModelTypes,
          modelsArray.ModelTypes,
          { Code: initialModelCode },
          {}
        );
        // console.log("modelsArray", modelsArray);
        // console.log("modelObj", modelObj);
        setSelectedModel(modelObj);
      }
    } else {
      // console.log("No family selected");
      setModelsArray([]);
      setSelectedModel("Unknown");
    }
  }, [selectedFamily]);

  const handleFamilyChange = (event) => {
    const family = event.target.value;
    setSelectedFamily(family);
  };

  const handleModelChange = (event) => {
    // On model dropdown change update selected model in both local state and item builder state.
    const model = event.target.value;
    setSelectedLocalModel(model);

    if (model != "Unknown") {
      const modelObj = find(modelsArray, { Code: model }, {});
      setSelectedModel(modelObj);
    } else {
      setSelectedModel("Unknown");
    }
  };

  return (
    <div className="family-model-dropdowns">
      <Row>
        <Col xs={4}>
          <h2 style={{ color: "#222222" }}>This item is for: </h2>
        </Col>
        <Col xs={4}>
          <div className="select">
            <p>Select Family</p>
            <select value={selectedFamily} onChange={handleFamilyChange}>
              <option value="Unknown">Unknown</option>
              {ricProductsArray &&
                ricProductsArray.length > 0 &&
                ricProductsArray.map((product, index) => {
                  return (
                    <option key={index} value={product.Code}>
                      {product.Name}
                    </option>
                  );
                })}
            </select>
          </div>
        </Col>
        <Col xs={4}>
          <div className="select">
            <p>Select Model</p>
            <select value={selectedLocalModel} onChange={handleModelChange}>
              <option value="Unknown">Unknown</option>
              {modelsArray &&
                modelsArray.length > 0 &&
                modelsArray.map((product, index) => {
                  return (
                    <option key={index} value={product.Code}>
                      {product.Name}
                    </option>
                  );
                })}
            </select>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default EarPiecesFamilyModel;
